import { render, staticRenderFns } from "./addresslist.vue?vue&type=template&id=1144c6ab&scoped=true"
import script from "./addresslist.vue?vue&type=script&lang=js"
export * from "./addresslist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1144c6ab",
  null
  
)

export default component.exports